/**
 * @generated SignedSource<<65df707e1f49c07b8ea76b1bfe1c696b>>
 * @relayHash d8de358e3ef63c4152f7fea5503e8f93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06524de9ce4b4e56e9bd120142e8735c122070b54be0c0ac8445cdc13e310aaf

import type { ConcreteRequest } from 'relay-runtime';
export type AgentStudioAgentVersionType = "DRAFT" | "LIVE" | "SUPERSEDED" | "%future added value";
export type RovoAgentConversationStartersNewQuery$variables = {
  agentAri: string;
  versionId?: string | null;
  versionType?: AgentStudioAgentVersionType | null;
};
export type RovoAgentConversationStartersNewQuery$data = {
  readonly agentStudio_agentById: {
    readonly __typename: "AgentStudioAssistant";
    readonly conversationStarters: ReadonlyArray<string> | null;
    readonly version: {
      readonly id: string;
      readonly type: AgentStudioAgentVersionType | null;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type RovoAgentConversationStartersNewQuery = {
  response: RovoAgentConversationStartersNewQuery$data;
  variables: RovoAgentConversationStartersNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionType"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "versionId",
        "variableName": "versionId"
      },
      {
        "kind": "Variable",
        "name": "versionType",
        "variableName": "versionType"
      }
    ],
    "kind": "ObjectValue",
    "name": "version"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "conversationStarters"
    },
    {
      "concreteType": "AgentStudioAgentVersion",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        }
      ]
    }
  ],
  "type": "AgentStudioAssistant"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RovoAgentConversationStartersNewQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentById",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "RovoAgentConversationStartersNewQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentById",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "06524de9ce4b4e56e9bd120142e8735c122070b54be0c0ac8445cdc13e310aaf",
    "metadata": {},
    "name": "RovoAgentConversationStartersNewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a250e08978d272de06629d57c8146948";

export default node;
